export default __webpack_public_path__ + "static/media/fc.b02c9a0e.jpg";